import React from 'react';
import { ScheduleDayProps } from './ScheduleDisplay';
import { ButtonV2, Divider, Flex, TextV2 } from '@withjoy/joykit';
import { formatDateAsDay, formatDateAsTimes } from '../formatDates';
import { ScheduleItemProps } from './ScheduleDisplay';
import { useEventHasPage } from '../hooks/useEventHasPage';
import { IconTextRow, ScheduleAction } from './TwoColumnDesktop';
import { BedIcon } from './Bed';
import { Directions } from './Directions';
import { AddToCalendar as AddToCalendarButton } from '@shared/components/AddToCalendar/AddToCalendar';
import { AddToCalendar } from './AddToCalendar';
import { DressCode, MapMarker } from '@withjoy/joykit/icons';
import { getCalendarProps, goToAccommodations, goToDirections } from '../navigation';
import { useTranslation } from '@shared/core';

export const TwoColumnMobileItem = (props: ScheduleItemProps) => {
  const { data } = props;
  const { startTimeISO8601TZ, endTimeISO8601TZ, name, description, dressCode, location } = data;
  const timeFormatted = formatDateAsTimes(startTimeISO8601TZ, endTimeISO8601TZ);
  const hasAccomPage = useEventHasPage('accommodations');
  const { tq } = useTranslation('generalEventSchedule');

  return (
    <Flex
      flexDirection="column"
      width="100"
      alignItems="center"
    >
      <TextV2
        typographyVariant="hed4"
        marginBottom={13}
        textAlign="center"
      >
        {name}
      </TextV2>
      <TextV2
        typographyVariant="label6"
        marginBottom={24}
        textAlign="center"
      >
        {timeFormatted}
      </TextV2>
      <Flex
        flexDirection="column"
        gap={16}
        marginBottom={40}
      >
        {location && (
          <ScheduleAction
            icon={<Directions />}
            label={tq`Get Directions`}
            variant="outline"
            onClick={() => {
              goToDirections(location);
            }}
          />
        )}
        {hasAccomPage && (
          <ScheduleAction
            icon={<BedIcon />}
            label={tq`Where to Stay`}
            onClick={goToAccommodations}
          />
        )}
        <AddToCalendarButton {...getCalendarProps(data)}>
          <ButtonV2
            startIcon={<AddToCalendar />}
            variant="ghost"
            intent="primary"
            height="fit-content"
            padding="0px"
          >
            {tq`Add to Calendar`}
          </ButtonV2>
        </AddToCalendarButton>
      </Flex>
      <Flex
        gap={24}
        alignItems={'flex-start'}
        flexDirection="column"
        width="100%"
      >
        {description && <TextV2 typographyVariant="body3">{description}</TextV2>}
        {dressCode && dressCode !== '' && (
          <IconTextRow icon={<DressCode />}>
            <TextV2 typographyVariant="body3">{dressCode}</TextV2>
          </IconTextRow>
        )}
        {location && location !== '' && (
          <IconTextRow icon={<MapMarker />}>
            <TextV2 typographyVariant="body3">{location}</TextV2>
          </IconTextRow>
        )}
      </Flex>
    </Flex>
  );
};

export const TwoColumnMobileDay = (props: ScheduleDayProps) => {
  const { data } = props;
  const { dateISO8601TZ, items } = data;
  const formattedDate = formatDateAsDay(dateISO8601TZ);

  return (
    <Flex
      flexDirection="column"
      width="100%"
      alignItems="center"
      marginBottom={60}
    >
      <TextV2
        typographyVariant="hed3"
        marginBottom="8px"
      >
        {formattedDate}
      </TextV2>
      <Divider marginBottom="64px" />
      <Flex
        flexDirection="column"
        gap="96px"
        width="100%"
      >
        {items.map(item => {
          return (
            <TwoColumnMobileItem
              key={item.id}
              data={item}
            />
          );
        })}
      </Flex>
    </Flex>
  );
};
